import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_edit",
  "use": "icon_edit-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_edit\"><path d=\"M4 35.6655V44H12.3345L36.9268 19.4077L28.5923 11.0732L4 35.6655V35.6655ZM43.3499 12.9846C44.2167 12.1178 44.2167 10.7065 43.3499 9.8397L38.1603 4.65009C37.2935 3.7833 35.8822 3.7833 35.0154 4.65009L30.9482 8.71732L39.2827 17.0518L43.3499 12.9846Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol